import React from "react";

export default function MSAccess_Avg() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Avg</h1>
      <p>This is the MSAccess_Avg component generated from the SQL JSON.</p>
    </div>
  );
}
